'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchAutosuggests = exports.searchBySortModeChange = exports.searchTypeOverride = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _evaluateSearchType = require('../utils/evaluateSearchType');

var _evaluateSearchType2 = _interopRequireDefault(_evaluateSearchType);

var _evaluateSortMode = require('../utils/evaluateSortMode');

var _evaluateSortMode2 = _interopRequireDefault(_evaluateSortMode);

var _evaluateSearchEvents = require('../utils/evaluateSearchEvents');

var _evaluateSearchEvents2 = _interopRequireDefault(_evaluateSearchEvents);

var _toLocationTiers = require('../utils/toLocationTiers');

var _toLocationTiers2 = _interopRequireDefault(_toLocationTiers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getPageSection = function getPageSection(totalCount, page) {
  return totalCount > 0 ? 'page ' + page : 'no results';
};

var whereAutoCorrect = function whereAutoCorrect(isAutocorrected) {
  return isAutocorrected ? 'autocorrected' : 'notautocorrected';
};

exports.default = function (state, props) {
  var query = props.query;
  var result = props.result;
  var userQueryId = props.userQueryId;
  var _query$keywords = query.keywords;
  var keywords = _query$keywords === undefined ? null : _query$keywords;
  var _query$classification = query.classification;
  var classification = _query$classification === undefined ? null : _query$classification;
  var _query$subclassificat = query.subclassification;
  var subclassification = _query$subclassificat === undefined ? null : _query$subclassificat;
  var _query$worktype = query.worktype;
  var worktype = _query$worktype === undefined ? null : _query$worktype;
  var _query$salarytype = query.salarytype;
  var salarytype = _query$salarytype === undefined ? null : _query$salarytype;
  var _query$salaryrange = query.salaryrange;
  var salaryrange = _query$salaryrange === undefined ? null : _query$salaryrange;
  var _query$daterange = query.daterange;
  var daterange = _query$daterange === undefined ? null : _query$daterange;
  var _query$sortmode = query.sortmode;
  var sortmode = _query$sortmode === undefined ? null : _query$sortmode;
  var _query$page = query.page;
  var page = _query$page === undefined ? '1' : _query$page;
  var _query$where = query.where;
  var where = _query$where === undefined ? null : _query$where;
  var _query$advertiserid = query.advertiserid;
  var advertiserid = _query$advertiserid === undefined ? null : _query$advertiserid;
  var _query$graduatesearch = query.graduatesearch;
  var graduatesearch = _query$graduatesearch === undefined ? null : _query$graduatesearch;
  var _result$totalCount = result.totalCount;
  var totalCount = _result$totalCount === undefined ? null : _result$totalCount;
  var _result$data = result.data;
  var data = _result$data === undefined ? [] : _result$data;
  var _result$suggestions = result.suggestions;
  var suggestions = _result$suggestions === undefined ? [] : _result$suggestions;
  var _result$location = result.location;
  var location = _result$location === undefined ? {} : _result$location;
  var _location$whereId = location.whereId;
  var whereId = _location$whereId === undefined ? null : _location$whereId;
  var _location$locationDes = location.locationDescription;
  var locationDescription = _location$locationDes === undefined ? null : _location$locationDes;
  var _location$areaDescrip = location.areaDescription;
  var areaDescription = _location$areaDescrip === undefined ? null : _location$areaDescrip;


  var searchType = (0, _evaluateSearchType2.default)(query, state.prevLocation, state.searchTypeOverride);
  var pageName = 'search:jobsearch:results ' + getPageSection(totalCount, page);
  var searchSortMode = (0, _evaluateSortMode2.default)(keywords, sortmode);
  var searchEvents = (0, _evaluateSearchEvents2.default)(state.prevLocation, state.searchBySortModeChange, state.searchTypeOverride, totalCount);
  var searchResultWhereAutoCorrect = whereAutoCorrect(suggestions.length > 0);
  var searchResultTiers = (0, _toLocationTiers2.default)(data);
  var searchResultWhereAutocorrectAndTiers = [searchResultWhereAutoCorrect].concat(_toConsumableArray(searchResultTiers)).join('|');

  return _extends({}, state, {
    pageName: pageName,
    searchType: searchType,
    searchSortMode: searchSortMode,
    searchTypeOverride: null,
    searchUserQueryId: userQueryId,
    searchKeywords: keywords,
    searchClassification: classification,
    searchSubClassification: subclassification,
    searchWorkType: worktype,
    searchSalaryRange: salaryrange,
    searchSalaryType: salarytype,
    searchDateRange: daterange,
    searchPageNumber: page,
    searchWhere: where,
    searchAdvertiserId: advertiserid,
    searchResultWhereId: whereId,
    searchResultTotalCount: totalCount,
    searchLocation: locationDescription,
    searchArea: areaDescription,
    searchGraduate: graduatesearch ? 'true' : null,
    searchResultWhereAutocorrectAndTiers: searchResultWhereAutocorrectAndTiers,
    searchEvents: searchEvents,
    searchBySortModeChange: false
  });
};

var searchTypeOverride = exports.searchTypeOverride = function searchTypeOverride(state, type) {
  return _extends({}, state, {
    searchTypeOverride: type
  });
};

var searchBySortModeChange = exports.searchBySortModeChange = function searchBySortModeChange(state, sortMode) {
  return _extends({}, state, {
    searchBySortModeChange: sortMode
  });
};

var searchAutosuggests = exports.searchAutosuggests = function searchAutosuggests(state, whereAutosuggestInteraction) {
  return _extends({}, state, {
    searchAutosuggests: whereAutosuggestInteraction
  });
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-analytics/build/reducers/search.js
 ** module id = 433
 ** module chunks = 0
 **/